import { FunctionComponent as F, useEffect, useState } from "react";
import TextTooltipOpt from "../Tooltip/TextTooltipOpt";
import LoadingGifSmall from "../Icons/LoadingGif/LoadingGifSmall";


interface IProps
{
  protocolId?: number,
  InitIcon: F<{ handleClick: () => Promise<void> }>;
  handleClick: () => Promise<void>;
  loadingTooltip?: string;
  retrievedIcon?: React.ReactElement;
}


const enum ReqStatus
{
  NotRetrieved,
  Retrieving,
  Retrieved,
  Error,
}

const RetrieveAndLoad: F<IProps> = props =>
{
  const [staus, setStatus] = useState<ReqStatus>(ReqStatus.NotRetrieved);

  const handleClick = async() =>
  {
    setStatus(ReqStatus.Retrieving);
    await props.handleClick();
    setStatus(ReqStatus.Retrieved);
  };

  useEffect(() =>
  {
    setStatus(ReqStatus.NotRetrieved);
  }, [props.protocolId])

  return (staus !== ReqStatus.Retrieved ?
    <>
      {(() =>
      {
        switch(staus)
        {
        case ReqStatus.NotRetrieved:
          return <props.InitIcon handleClick={handleClick}/>;
        case ReqStatus.Retrieving:
          return(
            <TextTooltipOpt showtooltip={Boolean(props.loadingTooltip)} lines={[String(props.loadingTooltip)]}>
              <LoadingGifSmall/>
            </TextTooltipOpt>);
        }
      })()}
    </> :
    (props.retrievedIcon ? props.retrievedIcon : <></>));
};

export default RetrieveAndLoad;
